import Card from '../components/Common/Card.vue';
import NoContent from '../components/Proposal/ProposalNoContent.vue';

export default {
    props: {
        editable: {
            type: Boolean,
            default: false,
        },
        className: {
            type: String,
            default: '',
        },
        values: {
            type: [Array, Object],
        },
        isEditing: {
            type: Boolean,
            default: false,
        },
        dimmed: {
            type: Boolean,
            default: false,
        },
        resetable: {
            type: Boolean,
            default: false,
        },
        advancedValues: {
            type: [Array, Object],
            default() {
                return {};
            },
        },
    },
    methods: {
        reset() {
            this.$emit('edit:end');
            this.$emit('edit:reset');
        },
        updateValue(value) {
            this.$emit('update:value', value);
        },
    },
    components: {
        'card-view': Card,
        'no-content': NoContent,
    },
};
